import React, { createContext, useContext, useEffect, useState } from 'react';
import { getGeoLocation } from '../services/api';

const GeoContext = createContext(null);

export const GeoProvider = ({ children }) => {
  const [geoData, setGeoData] = useState(null);

  useEffect(() => {
    getGeoLocation().then(data => {
      if (data) setGeoData(data);
    });
  }, []);

  return <GeoContext.Provider value={geoData}>{children}</GeoContext.Provider>;
};

export const useGeo = () => useContext(GeoContext);
